import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import momentDurationFormatSetup from 'moment-duration-format';

//- Material UI / Style
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';

//containers
import AuthUserContainer from '../containers/AuthUser';
import UserContainer from '../containers/User';

//- UI / Form
import FormSubmitButton from '../components/form/FormSubmitButton';
import SavingDialog from '../components/dialogs/SavingDailog';

import SectionHeader from '../components/SectionHeader';
import FormContainer from '../components/FormContainer';
import Note from '../components/Note';
import FormCheckbox from '../components/form/FormCheckbox';
// import TimeClockLocationSelect from "../components/advancedForm/TimeClockLocationSelect";
import LocationSelect from '../components/advancedForm/LocationSelect';
import UserPicker from '../components/advancedForm/UserPicker';
import DriverPermissionPicker from '../components/advancedForm/DriverPermissionPicker';

momentDurationFormatSetup(moment);

const styles = () => {
	return {};
};

class SaveUserDriver extends Component {
	constructor(props) {
		super(props);

		const userId = parseInt(_.get(this.props, 'match.params.userId'), 10);
		this.state = {
			isUpdate: true,
			userId,

			formFieldError: {},
			companyDepartmentMap: {},
			permissionMap: {},

			isSavingOpen: false,
			savingStatus: undefined,
			trainingAtLocationId: '',
		};
	}

	static getDerivedStateFromProps(props, state) {
		const { user } = props;
		const { isUpdate } = state;
		const isDriver = isUpdate && user && user.role === 'driver';
		return { isDriver };
	}

	componentDidMount() {
		const { user, getUser } = this.props;
		const { userId, isUpdate } = this.state;

		if (!isUpdate) {
			return;
		}

		if (user) {
			this.fillForm({ user });
		} else {
			getUser({ params: { userIds: [userId] } });
		}
	}

	componentDidUpdate(prevProps, prevState, snapShot) {
		const { user } = this.props;

		if (_.isUndefined(prevProps.user) && !_.isUndefined(user)) {
			this.fillForm({ user });
		}
	}

	fillForm = ({ user }) => {
		if (!user) {
			return;
		}

		const newState = {};
		['isModifiedDuty', 'isTrainee', 'supervisorUserId', 'trainingAtLocationId'].forEach((key) => {
			if (_.isNil(user[key])) {
				return;
			}
			newState[key] = user[key];
		});

		const { permissions } = user;
		newState.permissionMap = {};
		_.forEach(permissions, (id) => {
			newState.permissionMap[id] = true;
		});

		this.setState(newState);
	};

	//- Path is always a string
	//- value is never an event (value.target)
	onChange = (value, path) => {
		const arrayPath = _.toPath(path);
		const basePath = _.head(arrayPath);
		let base = this.state[basePath];
		let newState = {};

		if (_.isArray(base) || _.isObject(base)) {
			base = _.cloneDeep(base);
			_.set(base, arrayPath.slice(1), value);
			newState[basePath] = base;
		} else {
			newState[basePath] = value;
		}

		//- Clear any errors on the path
		let formFieldError = Object.assign({}, this.state.formFieldError);
		delete formFieldError[path];
		newState.formFieldError = formFieldError;

		this.setState(newState);
	};

	closeSavingDialog = () => {
		this.setState({ onContinue: false });
	};

	continueSavingDialog = () => {
		this.props.history.push(`/users`);
	};

	handleSave = () => {
		const { updateUser, showErrors } = this.props;
		const {
			isUpdate,
			userId,
			isModifiedDuty,
			isTrainee,
			trainingAtLocationId,
			supervisorUserId,
			permissionMap,
		} = this.state;
		const params = { userId, isModifiedDuty, isTrainee, supervisorUserId };

		if (trainingAtLocationId) {
			params.trainingAtLocationId = trainingAtLocationId;
		}

		if (isTrainee && !trainingAtLocationId) {
			showErrors('You must pick a training location for trainees.');
			return;
		}

		const permissions = [];
		_.keys(permissionMap).forEach((key) => {
			if (permissionMap[key]) {
				permissions.push(key);
			}
		});
		params.permissions = permissions;

		this.setState({
			isSavingOpen: true,
			savingStatus: 'saving',
		});

		if (!isUpdate) {
			showErrors('You can only update drivers. Drivers come from GeoTab');
			return;
		}

		updateUser({
			params,
			callback: this.postSave,
		});
	};

	postSave = (err) => {
		const { showErrors } = this.props;

		if (err) {
			this.setState({ isSavingOpen: false });
			return showErrors(_.isArray(err) ? err : [err]);
		}

		this.setState({
			savingStatus: 'done',
		});
	};

	getInputProps = (path, defaultValue) => {
		return {
			key: path,
			path,
			value: this.getValue(path, defaultValue),
			checked: this.getValue(path, defaultValue),
			error: this.getError(path),
			onChange: this.onChange,
			gridProps: { md: 12 },
		};
	};

	getValue = (path, defaultValue) => {
		const _d = _.isUndefined(defaultValue) ? '' : defaultValue;
		return _.get(this.state, path, _d);
	};

	getError = (path) => {
		return _.get(this.state.formFieldError, path);
	};

	render() {
		const { permissions, user } = this.props;

		const { isSavingOpen, savingStatus, isUpdate, isDriver } = this.state;

		if (!isDriver) {
			return <div>You can only update drivers on this page.</div>;
		}

		if (!permissions || !_.includes(permissions, 'canAddAndUpdateUsers')) {
			return <div>You do not have valid permissions to view this page.</div>;
		}
		if (isUpdate && !user) {
			return null;
		}

		const action = isUpdate ? 'Update' : 'Add';
		return (
			<FormContainer headline={`${action} Driver`}>
				<Grid item xs={12}>
					<div style={{ fontSize: 24, marginTop: 15 }}>
						<strong>
							{user.firstName} {user.lastName}
						</strong>{' '}
						({user.geoTabName})
					</div>
				</Grid>

				<Grid item xs={12}>
					<Note
						label={`Majority of driver information is synced from GeoTabs and cannot be updated here.
						All updates must be made in GeoTabs and will be synced with Sphere every 10 minutes.`}
					/>
				</Grid>

				<SectionHeader label="Time Clocks" gridProps={{ md: 12 }} />
				<FormCheckbox
					{...this.getInputProps('isModifiedDuty', false)}
					label={'Driver is on modified duty'}
					helpText={'Driver is not subject to time clock rules (10 hours, 34 rest, etc)'}
					gridProps={{ sm: 12 }}
				/>

				<FormCheckbox
					{...this.getInputProps('isTrainee', false)}
					label={'Driver is a trainee'}
					helpText={'Trainees are not subject to time clock rules (10 hours, 34 rest, etc)'}
					gridProps={{ sm: 12 }}
				/>

				<LocationSelect
					{...this.getInputProps('trainingAtLocationId', 'Training at Which Location')}
					label={'Training at Which Location'}
					gridProps={{ sm: 6 }}
					disabled={!this.state.isTrainee}
				/>

				<Grid item xs={12}>
					<Note
						label={`Do not set unless you really have to override their supervisor.
				A driver's supervisor is determined automatically by what terminal they are 
				currently scheduled at OR if they are a trainee, which location they are training at. 
				Usually you only need to set this for TMs that are in GeoTab for some reason.
			`}
					/>
				</Grid>

				<UserPicker
					{...this.getInputProps('supervisorUserId')}
					label="Supervisor"
					helpText="Who will get alerted when shifts get flagged"
					whoToShow={'nonDriversOnly'}
					gridProps={{ sm: 6 }}
				/>

				<DriverPermissionPicker {...this.getInputProps('permissionMap')} />

				<FormSubmitButton onClick={this.handleSave} buttonText={`${action} Driver`} />

				<SavingDialog
					open={isSavingOpen}
					onClose={this.closeSavingDialog}
					onContinue={this.continueSavingDialog}
					processingText={isUpdate ? 'Updating User' : 'Creating new user'}
					successText={'User saved successfully. Thank you.'}
					status={savingStatus}
				/>
			</FormContainer>
		);
	}
}

SaveUserDriver.propTypes = {
	addUser: PropTypes.func.isRequired,
	updateUser: PropTypes.func.isRequired,
	user: PropTypes.object,

	showErrors: PropTypes.func.isRequired,
	authUser: PropTypes.object,
	classes: PropTypes.object.isRequired,
};

export default _.flow([withStyles(styles), AuthUserContainer, UserContainer])(SaveUserDriver);
